export default "__VITE_ASSET__DPC9yzex__"